// extracted by mini-css-extract-plugin
module.exports = {"bg":"RingProfile-module__bg___3fTdt","content":"RingProfile-module__content___2AQ0o"};